import React from 'react'
import {Button, Header, List, Step} from 'semantic-ui-react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import {docco} from 'react-syntax-highlighter/dist/esm/styles/hljs'
import {stripIndent} from 'common-tags'
import {useSafeState} from '../../../../hook'

const GettingStartedOverview = () => {
  const [state, setState] = useSafeState({step: 1})

  const {step} = state

  const onStepClicked = (step) => {
    setState({...state, step})
  }

  return (
    <div className='doc-section'>
      <Header as='h2'>Getting Started</Header>
      <p>Getting started with Service Mocks should take 5 minutes or less.</p>
      <Step.Group ordered>
        <Step active={step === 1} completed={step > 1} onClick={() => onStepClicked(1)}>
          <Step.Content>
            <Step.Title>Create Account</Step.Title>
          </Step.Content>
        </Step>

        <Step active={step === 2} completed={step > 2} onClick={() => onStepClicked(2)}>
          <Step.Content>
            <Step.Title>Create Service Mock</Step.Title>
          </Step.Content>
        </Step>

        <Step active={step === 3} onClick={() => onStepClicked(3)}>
          <Step.Content>
            <Step.Title>Send A Request!</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>

      <div style={{marginTop: '15px'}}>
        {
          step === 1 && (
            <>
              <Header as='h3' dividing>Steps:</Header>
              <List relaxed>
                <List.Item>1. Visit <a href='/c/auth/login' target='_blank'>login</a> page.</List.Item>
                <List.Item>2. Click "Create Account" button.</List.Item>
                <List.Item>3. Fill in email, password and other info.</List.Item>
                <List.Item>4. Click "Create Account" button</List.Item>
                <List.Item>5. Perfect! You have an account</List.Item>
              </List>
              <Button onClick={() => onStepClicked(2)} basic>Next</Button>
            </>
          )
        }
        {
          step === 2 && (
            <>
              <Header as='h3' dividing>Steps:</Header>
              <List relaxed>
                <List.Item>1. Visit <a href='/c/services' target='_blank'>mocks</a> page.</List.Item>
                <List.Item>2. Click the "Add Service" button on the left side of your screen.</List.Item>
                <List.Item>3. Give it a name of "my-first-service" and save</List.Item>
                <List.Item>4. You'll automatically get a default version (1.0.0), environment (default), and resource (/hello-world).</List.Item>
                <List.Item>5. Let's add a new version, environment, resource, and response for the sake of learning.</List.Item>
                <List.Item>6. Select "my-first-service" in the left menu, click the version dropdown and click "Manage Versions".</List.Item>
                <List.Item>7. Click "Add Version", give it a name of "1.0.1", and click "Add".</List.Item>
                <List.Item>8. In your version table, toggle 1.0.1 to "published" so that it's our default version selection for the service.</List.Item>
                <List.Item>9. Click "Done" button, find and click the "Add Environment" button.</List.Item>
                <List.Item>10. Give it a name of "my-first-environment", click "Return", and give it a body of {'{"name": "my-first-servicee"}'}</List.Item>
                <List.Item>10. Click "Add", then expand the "my-first-environment."</List.Item>
                <List.Item>11. Click "Add Resource", give it a Verb of "GET", and path of "/my-first-resource", then click "Add", and expand resource.</List.Item>
                <List.Item>12. Expand the new resource, click "Add Response" button, give it a name of "my-first-response, and click "Add" </List.Item>
              </List>
              <Button onClick={() => onStepClicked(1)} basic>Previous</Button>
              <Button onClick={() => onStepClicked(3)} basic>Next</Button>
            </>
          )
        }
        {
          step === 3 && (
            <>
              <Header as='h3' dividing>Steps:</Header>
              <List relaxed>
                <List.Item>1. Visit <a href='/c/services' target='_blank'>mocks</a> page.</List.Item>
                <List.Item>2. Select your the "my-first-service" mock</List.Item>
                <List.Item>3. Select the "1.0.1" version if it isn't already.</List.Item>
                <List.Item>4. Expand the "my-first-environment"</List.Item>
                <List.Item>5. Copy the url and use it along w/ the resource path of "/my-first-resource" in your request</List.Item>
                <List.Item>6. See below for an example curl request.</List.Item>
                <List.Item>7. And that's it! You've just created and used your first Service Mock!</List.Item>
              </List>
              <Header as='h3' dividing>Example Request (cURL)</Header>
              <div>
                <SyntaxHighlighter language="bash" style={docco}>
                  {
                    stripIndent
                    `
                      #!/bin/bash
                      curl -X GET https://serivcemocks.com/m/<your-account-name>/my-first-service/1.0.1/my-first-environment/my-first-resource
                    `
                  }
                </SyntaxHighlighter>
              </div>
              <Button onClick={() => onStepClicked(2)} basic>Previous</Button>
            </>
          )
        }
      </div>
    </div>
  )
}

export {GettingStartedOverview}

export default GettingStartedOverview